// extracted by mini-css-extract-plugin
module.exports = {"btn":"Dropdown--btn--QHAOP","icon":"Dropdown--icon--1dyEx","list":"Dropdown--list--1d1eP","item":"Dropdown--item--1Dpu1"};